import { HttpMethod } from "@/types/https";
import { apiWorkchestraCall } from "../base";
import { ENDPOINT } from "../endpoints";

export interface UserItem {
  id: number;
  userName: string;
  fullName: string;
  email: string;
  costCenters: string;
  lockoutEnabled: boolean;
}

export interface UserPagedResponse {
  items: UserItem[];
  totalItemCount: number;
  totalPages: number;
}

export const UsersPaged = (params: {
  currentPage?: number;
  itemsPerPage?: number;
  searchText?: string;
}) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `UsersPaged_${stringParams}`,
    handle: (): Promise<UserPagedResponse> =>
      apiWorkchestraCall<UserPagedResponse>({
        params,
        url: ENDPOINT.USER_PAGED,
        method: HttpMethod.GET,
      }),
  };
};
